// ABOUTME: Configuration for external channels tab in warehouse settings
// ABOUTME: Defines tab structure and icons for external channels management page

import IntegrationInstructionsIcon from '@mui/icons-material/IntegrationInstructions';

export const settingsWarehouseExternalChannelsConfig = {
    all: {
        title: 'external_channels',
        subtitle: 'external_channels',
        icon: <IntegrationInstructionsIcon />,
        isSingleDataGrid: true,
    },
};
